import { Icon } from '@betty/moonlight';
import { useReferrerPromo } from '@betty/promos';
import AccountLink, { AccountLinkProps } from '../AccountLink/AccountLink';
import { useMemo } from 'react';

function LinksMenu() {
  const { referrerPromo } = useReferrerPromo();

  const links = useMemo<AccountLinkProps[]>(
    () => [
      {
        labelKey: 'link_MyProfile',
        navigateTo: 'MyProfile',
        icon: <Icon name="accountCircle" />,
        key: 'acc-det',
      },
      {
        labelKey: 'link_2fa',
        navigateTo: 'TwoFactorAuthentication',
        icon: <Icon name="lock" />,
        key: 'acc-mfa',
      },
      {
        labelKey: 'link_TransactionHistory',
        navigateTo: 'TransactionHistory',
        icon: <Icon name="paid" />,
        key: 'acc-his',
      },
      {
        labelKey: 'link_ResponsibleGaming',
        navigateTo: 'ResponsibleGaming',
        icon: <Icon name="priceCheck" />,
        key: 'acc-lim',
      },
      {
        labelKey: 'link_GamingTransactions',
        navigateTo: 'GamingHistory',
        icon: (
          <Icon
            name="slotsDark"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-tra',
      },
      {
        labelKey: 'link_CoinsGamingTransactions',
        navigateTo: 'CoinsGamingTransactions',
        icon: (
          <Icon
            name="bettyCoin"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-bty-tra',
      },
      {
        labelKey: 'link_Sessions',
        navigateTo: 'SessionHistory',
        icon: <Icon name="timelapse" />,
        key: 'acc-ses',
      },
      {
        labelKey: 'link_ManageNotifications',
        navigateTo: 'Notifications',
        icon: (
          <Icon
            name="inboxBell"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-not',
      },
      referrerPromo?.slug
        ? {
            labelKey: 'link_InviteFriends',
            navigateTo: 'ReferrerPromoScreen',
            path: `/promos/${referrerPromo.slug}`,
            icon: <Icon name="inviteFriend" />,
            key: 'acc-inv',
          }
        : {
            labelKey: '',
            navigateTo: '',
            icon: <Icon name="inviteFriend" />,
            key: 'acc-inv',
          },
    ],
    [referrerPromo],
  );

  return links.map((link) => <AccountLink {...link} key={link.key} />);
}

export default LinksMenu;
